






































































import {cloneDeep} from 'lodash';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Pane, Splitpanes} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import Breadcrumbs from '@c/controls/Breadcrumbs.vue';
import NodesTree from '@/components/nodesTree/NodesTree.vue';
import Loading from '@c/controls/Loading.vue';
import {Can} from '@casl/vue';
import {NodeData} from '@/system/nodes/interfaces';
import nodeModule from '@/store/modules/entities/nodeModule';
import NodeComponent from '@/components/nodeComponent/NodeComponent.vue';

@Component({
  components: {
    Splitpanes,
    Pane,
    Breadcrumbs,
    NodesTree,
    Loading,
    Can,
    NodeComponent,
  },
})
export default class NodesView extends Vue {
  loadingTree = false;
  errorTree = false;

  // Ключ для перерисовки компоненты узла
  key = 0;

  selectedNode: NodeData | null = null;

  items: NodeData[] = [];

  // Строка поиска
  search = '';

  // Выбранный путь в дереве структуры предприятия
  nodesPath: NodeData[] = [];

  // Очистить строку поиска
  clearSearch() {
    this.search = '';
  }

  onChangeNode(item: NodeData) {
    this.selectedNode = item;
    this.newRoute(item);
  }

  newRoute(selectedNode: any) {
    if (selectedNode)
      this.$router.push({path: `/nodes/${selectedNode.id}`}).catch(() => {
        return 0;
      });
  }

  @Watch('selectedNode')
  async nodeChanged(selectedNode: NodeData | null) {
    if (selectedNode && selectedNode.id) {
      this.nodesPath = this.getPathByNodeId(selectedNode.id);
      this.key++;
    }
  }

  getPathByNodeId(id: number): NodeData[] {
    const stack = [...this.items];
    const prev: Record<string, NodeData> = {};
    while (stack.length) {
      const x = stack.pop();
      if (x && x.id == id) {
        const path: NodeData[] = [];
        let node = x;
        path.push(node);
        while (prev[node.id ? node.id : 0]) {
          node = prev[node.id ? node.id : 0];
          path.push(node);
        }
        path.reverse();
        return path;
      }
      if (x && x.children)
        x.children.forEach(c => {
          if (c.id) {
            prev[c.id] = x;
            stack.push(c);
          }
        });
    }
    return [];
  }

  async mounted() {
    await this.loadTree();
    const nodeId = this.$route.params.id;
    if (nodeId) {
      const {data} = await nodeModule.edit(nodeId);
      this.selectedNode = data;
    }
  }

  addIdsToName(item: NodeData) {
    item.name = item.id + '.' + item.name;
    if (item.children) item.children.forEach((child: any) => this.addIdsToName(child));
  }

  checkCorrectLevelNode = (parentType: number, node: NodeData) => node.type < parentType;

  checkChildren(item: NodeData) {
    if (item.children && item.children.length) {
      item.children.forEach(node => {
        if (item.children && item.children.length) {
          if (this.checkCorrectLevelNode(item.type, node)) {
            node.leveTypeError = true;
          }
          node.parent = {name: item.name, type: item.type};
          this.checkChildren(node);
        }
        return;
      });
    }
  }

  // Загрузка дерева
  async loadTree() {
    await nodeModule.fetchAll();
    try {
      this.loadingTree = true;
      const temp = cloneDeep(nodeModule.all);
      temp.forEach(item => {
        this.checkChildren(item);
      });
      this.items = temp;
    } catch {
      this.errorTree = true;
    } finally {
      this.loadingTree = false;
    }
  }
}
